import { Box } from '@mui/material'
import { ReactNode } from 'react'

export function UIOutlineTag({ children, sx = {} }: { children: ReactNode; sx?: object }) {
  const containerSX = {
    ...sx,
    display: 'inline-block',
    background: '#fff',
    paddingLeft: '8px',
    paddingRight: '8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    textAlign: 'center',
    fontSize: '0.875rem',
    width: 'fit-content',
  }

  return <Box sx={containerSX}>{children}</Box>
}
